import reduceReducers from "reduce-reducers";

import { ECONTRACT_SPECIAL_CONDITION } from "constants/actionTypes";

import {
  apiModelOfflineCreateReducer,
  apiModelOfflineDeleteReducer,
  apiModelOfflineFetchReducer,
  apiModelOfflineUpdateReducer,
} from "lib/reducers";
import { deserializeEContractSpecialCondition } from "lib/serializers/eContractSpecialConditions";

const create = apiModelOfflineCreateReducer(ECONTRACT_SPECIAL_CONDITION, {
  deserializer: deserializeEContractSpecialCondition,
});

const fetch = apiModelOfflineFetchReducer(ECONTRACT_SPECIAL_CONDITION, {
  deserializer: deserializeEContractSpecialCondition,
  clearOnRequest: false,
});

const update = apiModelOfflineUpdateReducer(ECONTRACT_SPECIAL_CONDITION, {
  deserializer: deserializeEContractSpecialCondition,
});

const destroy = apiModelOfflineDeleteReducer(ECONTRACT_SPECIAL_CONDITION);

const EContractSpecialConditionsReducer = reduceReducers(
  create,
  fetch,
  update,
  destroy,
);

export default EContractSpecialConditionsReducer;
